/**
 * Cities API service
 */

import { httpClient } from '@/utils/httpClient';
import type { APICity, APICityRequest, DRFPaginatedResponse } from '@/types';

export interface CityListParams {
    page?: number;
    page_size?: number;
    province?: number;
}

const buildQuery = (params: CityListParams): string => {
    const usp = new URLSearchParams();
    if (params.page !== undefined) usp.append('page', String(params.page));
    if (params.page_size !== undefined) usp.append('page_size', String(params.page_size));
    if (params.province !== undefined) usp.append('province', String(params.province));
    const s = usp.toString();
    return s ? `?${s}` : '';
};

export const citiesService = {
    async list(params?: CityListParams): Promise<DRFPaginatedResponse<APICity>> {
        const qs = buildQuery(params ?? {});
        return httpClient.get<DRFPaginatedResponse<APICity>>(`/cities/${qs}`);
    },

    async getById(id: number): Promise<APICity> {
        return httpClient.get<APICity>(`/cities/${id}/`);
    },

    async create(data: APICityRequest): Promise<APICity> {
        return httpClient.post<APICity, APICityRequest>('/cities/', data);
    },

    async update(id: number, data: APICityRequest): Promise<APICity> {
        return httpClient.put<APICity, APICityRequest>(`/cities/${id}/`, data);
    },

    async remove(id: number): Promise<void> {
        return httpClient.delete<void>(`/cities/${id}/`);
    },
};

export default citiesService;
